import Hls from "hls.js";
import { useVideoPlayer2SetupStart } from "./use-video-player-2-setup-start";

export function useVideoPlayer2HlsSetup() {
  useVideoPlayer2SetupStart(({ player, video }) => {
    if (!player.hls) return;

    const hls = player.hls;

    hls.loadSource(player.props.url);
    hls.attachMedia(video);

    // Populate quality levels when manifest is parsed
    hls.on(Hls.Events.MANIFEST_PARSED, (_event, data) => {
      const levels = data.levels
        .map((level, index) => ({
          id: index,
          label: level.height ? `${level.height}p` : `Level ${index}`,
          height: level.height,
          bitrate: level.bitrate,
        }))
        .reverse();

      levels.unshift({
        id: -1,
        label: player.trans("auto"),
        height: 0,
        bitrate: 0,
      });

      player.qualityLevels = levels;
      // Set the initial quality level to the highest quality (index 1 since index 0 is "Auto")
      player.currentQualityLevel = levels[1];
      player.isReady = true;

      setTimeout(() => {
        player.triggerEvent("qualityLevels.setup", player);
      }, 200);
    });

    hls.on(Hls.Events.ERROR, (_event, data) => {
      console.error("HLS Error:", data);
      if (data.fatal) {
        player.$lazyGetter("error", () => data);
        player.triggerEvent("error", player);
        switch (data.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
            console.error("Fatal network error encountered, try to recover");
            hls.startLoad();
            break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            console.error("Fatal media error encountered, try to recover");
            hls.recoverMediaError();
            break;
          default:
            console.error("Cannot recover from error");
            hls.destroy();
            break;
        }
      }
    });
  });

  // useEffect(() => {
  //   if (!player.hls || !player.props.refreshUrlCallback) return;

  //   const interval = setInterval(() => {
  //     const video = player.videoRef.current!;
  //     const currentTime = video.currentTime ?? 0;

  //     player.props.refreshUrlCallback?.(player.url).then(url => {
  //       if (!player.hls) return;

  //       console.log("Refreshing stream URL", url);

  //       player.hls.detachMedia(); // Detach current source
  //       player.hls.loadSource(url); // Load new URL
  //       player.hls.attachMedia(video); // Reattach

  //       player.url = url;

  //       // Resume from where it left off
  //       const resume = () => {
  //         if (!video) return;
  //         video.currentTime = currentTime;
  //         video.play().catch(console.warn);
  //         player.hls?.off(Hls.Events.BUFFER_APPENDED, resume); // Clean up listener
  //       };

  //       // Wait until new buffer is ready
  //       player.hls.on(Hls.Events.BUFFER_APPENDED, resume);
  //     });
  //   }, player.props.refreshUrlEvery || 10_000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [
  //   player.hls,
  //   // player.props,
  //   // player.props.refreshUrlCallback,
  //   player.props.refreshUrlEvery,
  // ]);
}
